<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-9 pl-0">
            <h3 class="modal-title">
              商品清單
            </h3>
          </div>
        </div>
        <div class="modal-body">
          <h5>註解:</h5>
          <div class="col-9 pl-0 note-area">
            {{message}}
          </div>
          <h5>商品:</h5>
          <table class="table insurance-green">
            <thead>
              <tr>
                <th style="width:30%" class="text-center">公司</th>
                <th style="width:70%" class="text-center">商品名稱</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in inputList"
              :key="`product-list-${i}`">
                <td>{{item.compnm}}</td>
                <td>{{item.name + item.plan_code}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoteAndProductListModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    inputList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.initData();
      }
    },
  },
  data() {
    return {
      message: "",
    };
  },
  methods: {
    initData() {
      this.message = this.inputList[0].message;
    },
  },
};
</script>
<style lang="scss" scoped>
.note-area {
  word-break: break-all;
}
</style>
